/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

function Seo({ title, metaTitle, description, meta, image, children }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            lang
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const defaultTitle = site.siteMetadata?.title

  const metaObject = [
    {
      name: `description`,
      content: metaDescription,
    },
    {
      property: `og:site_name`,
      content: site.siteMetadata.title,
    },
    {
      property: `og:title`,
      content: metaTitle ?? title,
    },
    {
      property: `og:description`,
      content: metaDescription,
    },
    {
      property: `og:type`,
      content: `website`,
    },
    {
      name: `twitter:card`,
      content: image ? `summary` : `summary_large_image`,
    },
    {
      name: `twitter:title`,
      content: metaTitle ?? title,
    },
    {
      name: `twitter:description`,
      content: metaDescription,
    },
    ...meta,
  ]

  if (image) {
    metaObject.push(
      ...[
        {
          name: `og:image`,
          content: image.image,
        },
        {
          name: `og:image:width`,
          content: image.width,
        },
        {
          name: `og:image:height`,
          content: image.height,
        },
        {
          name: `twitter:image:src`,
          content: image.image,
        },
        {
          name: `twitter:image:width`,
          content: image.width,
        },
        {
          name: `twitter:image:height`,
          content: image.height,
        },
      ]
    )
  }

  return (
    <Helmet
      htmlAttributes={{
        lang: site.siteMetadata.lang,
      }}
      title={title}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      meta={metaObject}
    >
      {children}
      <script async src="https://www.googletagmanager.com/gtag/js?id=UA-130795909-1" />
      <script type="text/javascript">{`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'UA-130795909-1');
      `}</script>

      <script type="text/javascript">{`
        !function(f,b,e,v,n,t,s)
        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '658339141622648');
        fbq('track', 'PageView');
      `}</script>

      <noscript>{`
        <img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=658339141622648&ev=PageView&noscript=1"/>
      `}</noscript>
    </Helmet>
  )
}

Seo.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

Seo.propTypes = {
  description: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
}

export default Seo
